"use strict";

const ConstructionToDoController = function () {
  const reviewRecommendedAction = function (e) {
    e.preventDefault();
    const enforcementId = $(e.currentTarget).data("enforcementId");
    ProjectEnforcementController.editEnforcementAction(enforcementId);
  };

  const clearFlaggedInspections = async function (projectIds) {
    try {
      await ToDoFunctions.showConfirmClearToDoListConfirm(projectIds.length, {
        selectedToDosName: "flagged inspection",
        confirmButton: "Clear Flagged Inspections",
      });
    } catch (e) {
      // User canceled message
      return;
    }

    await ApiCalls.constructionToDoClearFlaggedInspections(projectIds);
    ToDoListController.loadTodos();
  };

  const clearLidFlaggedInspections = async function (projectIds) {
    try {
      await ToDoFunctions.showConfirmClearToDoListConfirm(projectIds.length, {
        selectedToDosName: "flagged inspection",
        confirmButton: "Clear Flagged Inspections",
      });
    } catch (e) {
      return;
    }

    await ApiCalls.lidToDoClearFlaggedInspections(projectIds);
    ToDoListController.loadTodos();
  };

  const canShowBmpInstallationTodos = function (user) {
    return UserRoles.getConfigForUser("showBmpInstallationTodos", user);
  };

  const canShowCompleteProjectTodos = function (user) {
    return UserRoles.getConfigForUser("showCompleteProjectTodos", user);
  };

  const canShowProjectEnforcementActionsTodos = function (user) {
    return UserRoles.getConfigForUser("showProjectEnforcementActionsTodos", user);
  };

  const canShowProjectInspectionTodos = function (user) {
    return UserRoles.getConfigForUser("showProjectInspectionTodos", user);
  };

  const loadToDoListeners = function ($container, { selectedTable }) {
    const onFlaggedInspectionsClear = function (e) {
      e.stopPropagation();
      const checkedRowIds = selectedTable
        .getAllSelectedRows()
        .toArray()
        .map((elm) => $(elm).data("relatedId"));
      clearFlaggedInspections(checkedRowIds);
    };

    $container.off("click", ".open-project-complete-modal");
    $container.on("click", ".open-project-complete-modal", openProjectCompleteModal);

    $container.off("click", ".open-post-active-modal");
    $container.on("click", ".open-post-active-modal", openPostActiveModal);

    $container.off("click", ".js-clear-flagged-inspections", onFlaggedInspectionsClear);
    $container.on("click", ".js-clear-flagged-inspections", onFlaggedInspectionsClear);

    $container.off("click", ".js-review-recommended-action");
    $container.on("click", ".js-review-recommended-action", reviewRecommendedAction);
  };

  var openPostActiveModal = function (e) {
    const $row = $(e.currentTarget).parents("tr");
    const id = $row.data("relatedId");
    PostActiveModal.renderAndShow(id);
  };

  var openProjectCompleteModal = function (e) {
    const $row = $(e.currentTarget).parents("tr");
    const id = $row.data("relatedId");
    ProjectCompleteModal.renderAndShow(id);
  };

  const canEnforceProject = function (user) {
    return user?.permissions?.can_create_enforcement ?? false;
  };

  const organizeOpenEnforcementTodos = function (data) {
    const currentUser = Session.getCurrentUserObject();
    const result = [];
    for (const datum of data) {
      const todoData = datum.constructionProjectOpenEnforcement;
      for (const enforcement of todoData?.additionalInfo || []) {
        TableDataFunctions.assignLidProjectIcon(datum, true);
        const issueDate = enforcement.issueDate
          ? DateTime.parseIsoDate(enforcement.issueDate)
          : null;

        if (!enforcement.currentEscalation) continue;

        result.push({
          id: datum.id,
          enforcementId: enforcement.id,
          todoId: todoData.todoId,
          tableIcon: datum.tableIcon,
          projectIdentifier: datum.projectIdentifier,
          name: datum.projectName,
          streetAddress: datum.streetAddress,
          contact: datum.displayContractor,
          displayEnforcementReason: _getDisplayEnforcementReason(enforcement.currentEscalation),
          displayLevel: Misc.getOptionNameByValue(
            FormSettings.getDropdownOptions("level", { tool: "indcom" }),
            enforcement.currentEscalation?.level,
          ),
          fine: enforcement.currentEscalation?.fine,
          issueDate: issueDate,
          displayIssueDate: issueDate ? DateTime.dateToGroupDisplayDate(issueDate) : issueDate,
          canIssueEnforcement: canEnforceProject(currentUser),
          assignee: todoData.assignee,
          iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
        });
      }
    }

    return result;
  };

  const organizeRecommendedActionTodos = function (data) {
    const currentUser = Session.getCurrentUserObject();
    const result = [];
    for (const datum of data) {
      const todoData = datum.constructionProjectFlaggedForEnforcementRecommendedAction;
      for (const enforcement of todoData?.additionalInfo || []) {
        TableDataFunctions.assignLidProjectIcon(datum, true);

        const issueDate = enforcement.issueDate
          ? DateTime.parseIsoDate(enforcement.issueDate)
          : null;

        if (!enforcement.currentEscalation) continue;

        result.push({
          id: datum.id,
          enforcementId: enforcement.id,
          todoId: todoData.todoId,
          tableIcon: datum.tableIcon,
          projectIdentifier: datum.projectIdentifier,
          name: datum.projectName,
          streetAddress: datum.streetAddress,
          contact: datum.displayContractor,
          displayEnforcementReason: _getDisplayEnforcementReason(enforcement.currentEscalation),
          displayLevel: Misc.getOptionNameByValue(
            FormSettings.getDropdownOptions("level", { tool: "indcom" }),
            enforcement.currentEscalation?.level,
          ),
          fine: enforcement.currentEscalation?.fine,
          issueDate: issueDate,
          displayIssueDate: issueDate ? DateTime.dateToGroupDisplayDate(issueDate) : issueDate,
          canIssueEnforcement: canEnforceProject(currentUser),
          displayRecommendedAction: BaseEnforcementAction().escalationActionOptions.find(
            (option) => option.value === enforcement.recommendedAction,
          )?.name,
          recommendedAction: enforcement.recommendedAction,
          assignee: todoData.assignee,
          iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
        });
      }
    }

    return result;
  };

  const _getDisplayEnforcementReason = function (escalation) {
    const displayEnforcementReason = Misc.getOptionNameByValue(
      FormSettings.getDropdownOptions("enforcement-reason"),
      escalation.enforcementReason,
    );
    const count = escalation.reasonCount ? ` (${escalation.reasonCount})` : "";

    return displayEnforcementReason + count;
  };

  const organizeFlaggedForNewEnforcementTodos = function (data) {
    const currentUser = Session.getCurrentUserObject();
    return data.map((datum) => {
      const todoData = datum.constructionProjectFlaggedForNewEnforcement;
      return {
        id: datum.id,
        projectId: datum.id,
        projectIdentifier: datum.projectIdentifier,
        projectName: datum.projectName,
        address: datum.streetAddress,
        contact: datum.displayContractor,
        todoId: todoData?.todoId,
        canIssueEnforcement: canEnforceProject(currentUser),
        assignee: todoData?.assignee,
        iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
      };
    });
  };

  const organizeReInspectionTodos = function (data) {
    const now = new Date();

    return data.map((datum) => {
      const todoData = datum.constructionProjectReInspection;
      const dueDate = DateTime.parseIsoDate(todoData?.dueDate);

      return {
        projectId: datum.id,
        relatedId: datum.id,
        iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
        projectIdentifier: datum.projectIdentifier,
        projectName: datum.projectName,
        address: datum.streetAddress,
        contact: datum.displayContractor,
        displayFindings: todoData?.additionalInfo?.displayFindings ?? [],
        lastInspectionDate: datum.lastInspectionDisplayDate,
        todoId: todoData?.todoId,
        assignee: todoData?.assignee,
        isPastDue: dueDate && dueDate < now,
        dueDate: dueDate ? DateTime.dateToGroupDisplayDate(dueDate) : null,
        canInspectProject: datum.canInspectProject,
      };
    });
  };

  const organizeMaintenanceResponseTodos = function (data) {
    const now = new Date();

    return data.map((datum) => {
      const todoData = datum.constructionProjectMaintenanceResponse;
      const dueDate = DateTime.parseIsoDate(todoData?.dueDate);

      return {
        projectId: datum.id,
        relatedId: datum.id,
        iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
        projectIdentifier: datum.projectIdentifier,
        projectName: datum.projectName,
        address: datum.streetAddress,
        contact: datum.displayContractor,
        displayFindings: todoData?.additionalInfo?.displayFindings ?? [],
        todoId: todoData?.todoId,
        assignee: todoData?.assignee,
        isPastDue: dueDate && dueDate < now,
        dueDate: dueDate ? DateTime.dateToGroupDisplayDate(dueDate) : null,
        canInspectProject: datum.canInspectProject,
      };
    });
  };

  const organizeRoutineInspectionTodos = function (data) {
    const now = new Date();

    return data.map((datum) => {
      const todoData = datum.constructionProjectRoutineInspection;
      const dueDate = DateTime.parseIsoDate(todoData?.dueDate);

      return {
        projectId: datum.id,
        relatedId: datum.id,
        iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
        projectIdentifier: datum.projectIdentifier,
        projectName: datum.projectName,
        address: datum.streetAddress,
        contact: datum.displayContractor,
        highPriority: datum.highPriority ? "Yes" : "No",
        lastInspectionDate: datum.lastInspectionDisplayDate,
        todoId: todoData?.todoId,
        assignee: todoData?.assignee,
        isPastDue: dueDate && dueDate < now,
        dueDate: dueDate ? DateTime.dateToGroupDisplayDate(dueDate) : null,
        canInspectProject: datum.canInspectProject,
      };
    });
  };

  const organizeInstallationInspectionTodos = function (data) {
    const result = [];
    for (const datum of data) {
      const todoData = datum.constructionInstallationInspection;
      for (const bmp of todoData?.additionalInfo || []) {
        result.push({
          projectId: datum.id,
          bmpId: bmp.bmpId,
          bmpName: bmp.bmpName,
          todoId: todoData.todoId,
          projectIdentifier: datum.projectIdentifier,
          projectName: datum.projectName,
          address: datum.streetAddress,
          contact: datum.displayContractor,
          iconClass: ConstructionIcon.getConstructionProjectIconClass(datum, true, true),
          displayCategory: "Installation Inspections",
          actionText: "Inspect",
          bmpIconClass: BmpFcsIcon.getTableIcon(
            undefined,
            bmp.bmpTypeCentralized,
            undefined,
            false,
            datum.phase,
            bmp.hasFailedInspections ? "red" : "no-inspection",
          ),
          remainingActivities: bmp.remainingActivities,
          assignee: todoData.assignee,
          canInspectProject: datum.canInspectProject,
          inspectionPrefillFields: bmp.inspectionPrefillFields,
          addInstallationUrl: Survey123UrlBuilder.getBmpInstallationInspectionUrl(
            bmp.inspectionPrefillFields,
          ),
        });
      }
    }
    return result;
  };

  const organizeCompleteProjectTodos = function (data) {
    const result = [];
    for (const datum of data) {
      const todoData = datum.constructionCompleteProject;
      const additionalInfo = todoData?.additionalInfo || {};
      const installationData = datum.constructionInstallationInspection;
      const iconClass = ConstructionIcon.getConstructionProjectIconClass(datum, true, true);

      const baseFields = {
        projectId: datum.id,
        relatedId: datum.id,
        projectIdentifier: datum.projectIdentifier,
        projectName: datum.projectName,
        address: datum.streetAddress,
        contact: datum.displayContractor,
        phase: datum.phase,
        canEditProject: datum.canEditProject,
        canInspectProject: datum.canInspectProject,
        todoId: todoData?.todoId,
        assignee: todoData?.assignee,
        iconClass,
      };

      // Close-out inspection
      if (additionalInfo.needsCloseOut) {
        const todo = {
          ...baseFields,
          category: "Inspection",
          incompleteTasks: "Close out inspection",
          actionText: "Inspect",
        };
        ConstructionProjectPopup.addInspectionButtonProps(todo, todo);
        result.push(todo);
      }

      // sBMP Installation
      const bmpsNeedingInspection = installationData?.additionalInfo || [];
      if (bmpsNeedingInspection.length > 0) {
        const numInspections = bmpsNeedingInspection.reduce(
          (sum, bmp) => sum + (bmp.remainingActivities?.length || 0),
          0,
        );
        result.push({
          ...baseFields,
          category: "sBMP Installation",
          incompleteTasks: {
            numBmps: bmpsNeedingInspection.length,
            numInspections: numInspections,
          },
          actionText: "See sBMP Tasks",
        });
      }

      // Project inventory
      if (additionalInfo.remainingRequiredFields?.length > 0) {
        result.push({
          ...baseFields,
          category: "Project Inventory",
          incompleteTasks: additionalInfo.remainingRequiredFields.join(", "),
          actionText: "Complete",
        });
      }
    }
    return result;
  };

  const getSortersDict = function () {
    const dateSorter = DateTime.dateComparator;
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;
    const alphaArrayQuantitySort = (a, b) => SortUtilities.arrayQuantitySort(a, b, alphaSorter);

    return {
      assignee: ToDoUserPicker.assigneeSort,
      projectIdentifier: alphaSorter,
      projectName: alphaSorter,
      name: alphaSorter,
      address: alphaSorter,
      streetAddress: alphaSorter,
      contact: alphaSorter,
      category: alphaSorter,
      bmpName: alphaSorter,
      displayEnforcementReason: alphaSorter,
      displayLevel: alphaSorter,
      displayFindings: alphaArrayQuantitySort,
      highPriority: alphaSorter,
      fine: numberSorter,
      issueDate: dateSorter,
      dueDate: dbDateStringSorter,
      lastInspectionDate: dbDateStringSorter,
    };
  };

  return {
    clearFlaggedInspections,
    clearLidFlaggedInspections,
    canShowBmpInstallationTodos,
    canShowCompleteProjectTodos,
    canShowProjectEnforcementActionsTodos,
    canShowProjectInspectionTodos,
    canEnforceProject,
    loadToDoListeners,
    organizeOpenEnforcementTodos,
    organizeRecommendedActionTodos,
    organizeFlaggedForNewEnforcementTodos,
    organizeRoutineInspectionTodos,
    organizeReInspectionTodos,
    organizeMaintenanceResponseTodos,
    organizeInstallationInspectionTodos,
    organizeCompleteProjectTodos,
    getSortersDict,
  };
};

module.exports = ConstructionToDoController();

const ApiCalls = require("../apiCalls");
const ToDoFunctions = require("../mapFunctions/toDoFunctions");
const ToDoListController = require("../mapFunctions/toDoListController");
const UserRoles = require("../login/userRoles");
const ProjectCompleteModal = require("./projectCompleteModal");
const PostActiveModal = require("./postActiveModal");
const DateTime = require("../dateTime");
const TableDataFunctions = require("../general/tableDataFunctions");
const Misc = require("../misc");
const FormSettings = require("../settings/formSettings");
const ConstructionIcon = require("../construction/constructionIcon");
const ProjectEnforcementController = require("./newEnforcement/projectEnforcementController");
const BaseEnforcementAction = require("../enforcement/baseEnforcementAction");
const BmpFcsIcon = require("../bmpfcs/bmpFcsIcon");
const ConstructionProjectPopup = require("./constructionProjectPopup");
const Session = require("../login/session");
const Survey123UrlBuilder = require("./survey123UrlBuilder");
const SortUtilities = require("../general/sortUtilities");
const ToDoUserPicker = require("../general/toDoUserPicker");
